<template>
    
</template>

<script>
export default {
    name : "Logout",
    data(){
        return {
            
        }
    },
    async created() {
       localStorage.clear()
       this.$router.push('/')
    },
    methods: {
       
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Logout.vue